import { isEmpty } from 'lodash';

export const LAST_1_HOUR = 'Last 1 hour';
export const LAST_3_HOURS = 'Last 3 hours';
export const LAST_6_HOURS = 'Last 6 hours';
export const LAST_24_HOURS = 'Last 24 hours';
export const CUSTOM_OPTION = 'Custom Date & Time';

export const OPTIONS_MAP = new Map([
  [LAST_1_HOUR, '1'],
  [LAST_3_HOURS, '3'],
  [LAST_6_HOURS, '6'],
  [LAST_24_HOURS, '24'],
  [CUSTOM_OPTION, 'Custom'],
]);

export const getCurrentOptionFromDates = (from: string, to: string) => {
  if (to === 'now') {
    switch (from) {
      case 'now-1h':
        return LAST_1_HOUR;
      case 'now-3h':
        return LAST_3_HOURS;
      case 'now-6h':
        return LAST_6_HOURS;
      case 'now-24h':
        return LAST_24_HOURS;
      default:
        return CUSTOM_OPTION;
    }
  }

  if (isEmpty(from) || isEmpty(to)) {
    return LAST_1_HOUR;
  }

  return CUSTOM_OPTION;
};
